export enum FaultOperationPathEnum {
  fault = '/',
  faults = '//',
  attachment = '/Files/',
  activity = '/Activities/',
  activityAttachment = '/Activities/Files',
  group = '/Groups/',
  groupActivity = '/Groups/Activities/',
  groupAttachment = '/Group/Files'
}
